import _ from "lodash";

/**
 * Detects country code from phone with format +x xxxxxxxxxx
 * @param {String} phone 
 * @returns String|null
 */
export const detectCountryCode = (phone) => {
    const arr = phone.split(' ');
    if (arr.length > 1 && /^\+\d{1,3}$/.test(arr[0])) {
        return arr[0]
    }
    return null;
}

/**
 * Get phone without country cude from phone with format +x xxxxxxxxx
 * @param {String} phone  
 * @returns String
 */
export const detectPhone = (phone) => {
    const rawPhone = phone.replace(/^\+\d{1,3}\s/, '');
    return rawPhone.replace(/\D/g, '');
}

/**
 * Fing phone must by country code
 * @param {String} phoneCode 
 * @returns String|null
 */
export const detectMask = (phoneCode, phoneCodes) => {
    const code = _.find(phoneCodes, {code: phoneCode});
    return code ? code.mask : null;
}

/**
 * Resolves a phone prefix row from dropdown value (prefix id) or legacy dial code.
 * @param {string|number} value
 * @param {Array} phonePrefixes
 * @returns {object|null}
 */
export const findPhonePrefixByOptionValue = (value, phonePrefixes) => {
    if (value === null || value === undefined || value === '' || !phonePrefixes?.length) {
        return null;
    }
    const byId = _.find(phonePrefixes, prefix => String(prefix.id) === String(value));
    if (byId) {
        return byId;
    }
    return _.find(phonePrefixes, { code: value }) || null;
};

/**
 * Resolves dial-code prefix; prefers preferredPrefixId when it matches the dial code (e.g. CA vs US +1).
 * @param {string} dialCode
 * @param {Array} phonePrefixes
 * @param {string|number} [preferredPrefixId]
 * @returns {object|null}
 */
export const findPhonePrefixByDialCode = (dialCode, phonePrefixes, preferredPrefixId) => {
    if (!dialCode || !phonePrefixes?.length) {
        return null;
    }
    if (preferredPrefixId !== null && preferredPrefixId !== undefined && preferredPrefixId !== '') {
        const byId = _.find(
            phonePrefixes,
            prefix => String(prefix.id) === String(preferredPrefixId)
        );
        if (byId && byId.code === dialCode) {
            return byId;
        }
    }
    return _.find(phonePrefixes, { code: dialCode }) || null;
};

export const detectValidator = (phoneCode, phoneCodes) => {
    const code = _.find(phoneCodes, {code: phoneCode});
    return code ? code?.validators : null;
}

export const applyMask = (phone, phoneCodes) => {
    if (/^[+]\d+ \d+$/.test(phone)) {
        const phoneMask = detectMask(detectCountryCode(phone), phoneCodes);
        const phoneWithoutCode = detectPhone(phone);
        if (phoneMask && phoneWithoutCode) {
            const phoneCode = detectCountryCode(phone);
            let result = `${phoneCode  } `;
            let i = 0;
            _.forEach(phoneMask, (c) => {
                if ((c === '9' || c === 'x') && phoneWithoutCode[i]) {
                    result += phoneWithoutCode[i];
                    i+=1;
                } else {
                    result += c;
                }
            });
            return result;
        }
    }
    return phone;
}

export const castMaskFormat = (mask) => {  
  return mask ? mask.replace(/\d/g, "#") : "(###) ###-####";
};

export const formatPhoneNumber = phone => {
  return phone.replace(/\D/g, "");
};